module.exports = __webpack_public_path__ + "static/img/good-detail-zhuanhua.c71bce25.png";